import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';
import moment from 'moment';

import DatePickerInput from '../../../DatePickerInput/DatePickerInput';
import LoadingState from '../../../LoadingState';

import s from './HealthRecordFilter.css';
import cx from 'classnames';


export default class HealthRecordFilter extends Component {
  static propTypes = {
    dateFormat: string,
    submitDateRangeCallback: func,
    loadingRecordSearch: bool,
    recordSearch: func,
    closeAlertDialog: func,
    openErrorDialog: func,
  };

  static defaultProps = {
    dateFormat: 'YYYY-MM-DD',
  };

  constructor(props) {
    super(props);

    this.state = {
      // POR-642 - no more default date range. We now return the latest 5 records
      startDate: null,
      endDate: null,
      maxDate: moment().format(props.dateFormat),
    };
  }

  handleStartDateChange = startDate => this.setState({ startDate });

  handleEndDateChange = endDate => this.setState({ endDate });

  handleSubmitDateRange = () => {
    const startDate = this.state.startDate;
    const endDate = this.state.endDate;

    if (!startDate || !endDate) {
      this.props.openErrorDialog({
        content: 'Please enter a start and end date.',
        okCallback: this.props.closeAlertDialog,
      });
    }
    else if (startDate && endDate) {
      this.props.recordSearch(startDate, endDate);
    }
    else {
      return false;
    }
  };

  render() {

    const getHealthRecordFilterBtn = () => {
      if (this.props.loadingRecordSearch) {
        return (
          <button
            type="submit"
            id="submitDatesToFilterBtn__pending"
            className={s.filterSubmitBtn}
            disabled
            onClick={this.handleSubmitDateRange}
          >
            <LoadingState context="healthFilter" />
          </button>
        );
      } else {
        return (
          <button
            type="submit"
            id="submitDatesToFilterBtn"
            className={cx(s.filterSubmitBtn, { [s.active]: this.state.startDate && this.state.endDate })}
            disabled={!this.state.startDate || !this.state.endDate}
            onClick={this.handleSubmitDateRange}
          >
            Submit
          </button>
        );
      }
    };

    // recordSearchIsLoading can be moved around anyplace we like to indicate LoadingState in the UI
    return (
      <div className={s.component}>
        <h3 className={s.filterTitle}>
          Filter Records
        </h3>
        <DatePickerInput
          className={s.dateFilter}
          dateFormat={this.props.dateFormat}
          id="recordFilter__startDate"
          isStartDate
          onChange={this.handleStartDateChange}
          value={this.state.startDate}
        />
        <DatePickerInput
          className={s.dateFilter}
          dateFormat={this.props.dateFormat}
          id="recordFilter__endDate"
          isEndDate
          maxDate={this.state.maxDate}
          onChange={this.handleEndDateChange}
          value={this.state.endDate}
        />
        {getHealthRecordFilterBtn()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordFilter/HealthRecordFilter.js